function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "tv-hi-dark_svg__a",
  x1: 37,
  y1: 31,
  x2: 155,
  y2: 149,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f6f6f6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("symbol", {
  id: "tv-hi-dark_svg__b",
  "data-name": "TV_ic_hi",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Bounding Box",
  fill: "none",
  d: "M0 192V0h192v192H0z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 44,
  width: 160,
  height: 100,
  rx: 4,
  ry: 4,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172 142H20a4 4 0 01-4-4v2a4 4 0 004 4h152a4 4 0 004-4v-2a4 4 0 01-4 4z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 46,
  width: 156,
  height: 88,
  rx: 2,
  ry: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M20 48h152v84H20z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fill: "url(#tv-hi-dark_svg__a)",
  d: "M20 48h152v84H20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.11 150a2 2 0 011.89-2h56.13a2 2 0 011.94 2M86.11 144h20v4h-20z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 138,
  r: 2,
  fill: "#e60000"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f4f4f4",
  d: "M126.11 149.94V152h-60v-2.06"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.06,
  d: "M66.11 150h60v2h-60zM86 144h20v4H86z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "TV_ic"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "TV_ic_hi",
  width: 192,
  height: 192,
  xlinkHref: "#tv-hi-dark_svg__b"
}));

var SvgTvHiDark = function SvgTvHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgTvHiDark;